









































import { FormField } from '@/types/Form.interface'
import { InputType } from '@/types/Input.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        availableFields: {
            type: Array as PropType<FormField[]>,
            required: true
        }
    },
    data() {
        return {
            field: null
        }
    },
    mounted() {
        this.field = this.availableFields[0] || null
    },
    computed: {
        inputType(): InputType {
            return this.field?.type || 'void'
        },
        items(): FormField[] {
            return this.availableFields.map((x: FormField) => {
                return {
                    text: x.name,
                    value: x.name,
                    type: x.name || 'undefined'
                }
            })
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        inputChange(val: string): void {
            this.field = this.availableFields.find(
                (field: FormField) => field.name === val
            )
        },
        submit(): void {
            //  If we have no field, do nothing
            if (!this.field) return

            //  Else, submit to parent
            this.$emit('submit', this.field)
        },
        popContactFieldHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Help',
                text: `These are the contact profile fields that update whenever a contact submits the form.`,
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        },
        popFieldTypeHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Help',
                text: `Field types determine what information can be submitted. The following field types are text, numbers, dropdowns, dates, and phones. Text can contain alphanumeric characters. Numbers may only contain numeric characters. Dates are in ISO8601 format but are handled automatically by the calander input field. Dropdowns may only contain answers that mach one of the provided options. Phone numbers must contain 10-11 numeric characters.`,
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        }
    }
})
